/* @flow */

import { type ContextRouter } from 'react-router-dom';
import * as React from 'react';

import RankingPage from '../../common/RankingPage';

const IceAdvancedRankingPage = (props: ContextRouter) => (
  <RankingPage
    kind="ice-a"
    onNextClick={() => {
      props.history.push('/ice-a/fields?skip_intro=1');
    }}
  />
);

export default IceAdvancedRankingPage;
